__turbopack_context__.v({
  "checkmarkIcon": "checkmark-icon-module-scss-module__oxVJTG__checkmarkIcon",
  "checkmarkIconImage": "checkmark-icon-module-scss-module__oxVJTG__checkmarkIconImage",
  "primary": "checkmark-icon-module-scss-module__oxVJTG__primary",
  "secondary": "checkmark-icon-module-scss-module__oxVJTG__secondary",
});
